import type { AssetWorkflowOptions } from '../../types';

export const addTagWorkflow: AssetWorkflowOptions = {
  workflowKey: 'addTagWorkflow',
  workflowType: 'addAssetWorkflow',
  assetType: 'tags',
  workflowIndex: 1,
  workflowName: 'Create Tag Workflow',
  workflowDescription: 'Create tags that you will apply to various elements of your supply chain',
  workflowStepOptions: [
    {
      workflowStepKey: 'partnerProvidedId',
      workflowStepNavigationName: 'Tag ID Alias',
      optional: true,
      workflowComponent: {
        workflowComponentType: 'textEntry',
        prompt: 'Enter a unique identifier for this tag',
        description: 'This is optional but will allow you to more easily reference this tag in API calls.',
        help: '',
      },
      includeInDefaultAssetNameRules: {
        includeInDefaultAssetName: true,
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'partnerProvidedId',
      },
    },
    {
      workflowStepKey: 'tag',
      workflowStepNavigationName: 'Tag',
      workflowComponent: {
        workflowComponentType: 'textEntry',
        prompt: 'Enter the tag value',
        description: 'This is the string value for tag will be applied to other assets',
        help: '',
      },
      includeInDefaultAssetNameRules: {
        includeInDefaultAssetName: true,
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'tag',
      },
    },
    {
      workflowStepKey: 'tagName',
      workflowStepNavigationName: 'Name',
      workflowComponent: {
        workflowComponentType: 'assetNameEntry',
        prompt: 'Enter the tag name',
        description: 'Enter the name of this tag. This should probably be the same as the tag value',
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'name',
      },
    },
    {
      workflowStepKey: 'tagDescription',
      workflowStepNavigationName: 'Description',
      workflowComponent: {
        workflowComponentType: 'textEntry',
        rows: 4,
        prompt: 'Enter a description (optional):',
        description: '',
        defaultValue: '',
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'description',
      },
    },
    {
      workflowStepKey: 'summary',
      workflowStepNavigationName: 'Configuration Summary',
      workflowComponent: {
        workflowComponentType: 'workflowSummary',
        title: 'Add Tag Summary',
        description: 'The tag will be created.  Please review your selections.',
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'ignore',
      },
    },
  ],
};
